import _ from 'lodash';
import { store } from '../redux';
import { systemAPI } from '../apis';

export function goToWardDrivePage() {
  const userId = store.getState()?.loginInfo?.userId;
  const corpId = store.getState()?.loginInfo?.corpID;
  const hospId = store.getState()?.loginInfo?.hospitalId;
  const wardId = store.getState()?.loginInfo?.wardId;
  const userRole = store.getState()?.userRole;
  const userRoleIdx = _.findIndex(userRole, { userId });
  if (userRoleIdx > -1) {
    const role = userRole[userRoleIdx];
    const urlIdx = _.findIndex(role?.wards, { wardId });
    if (urlIdx > -1) {
      systemAPI.driveClickrate(
        {
          hospId,
          corpId,
          wardId,
        },
        { isHideLoading: true }
      );
      setTimeout(() => {
        window.open(role?.wards[urlIdx]?.drivePath);
      }, 200);
    }
  } else {
    return null;
  }
}
